import React, { Component } from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import { OutsideClick } from 'wanderu-hocs';
import { CloseX } from 'wanderu-icons';

import styles from './Lightbox.scss';

class Lightbox extends Component {
    static propTypes = {
        id: PropTypes.string,
        innerClassName: PropTypes.string,
        showCloseButton: PropTypes.bool.isRequired,
        onHide: PropTypes.func,
        title: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.object,
        ]),
        closeModalOnOutsideClick: PropTypes.bool,
    };

    static defaultProps = {
        innerClassName: '',
        showCloseButton: true,
        onHide() { },
        title: '',
        closeModalOnOutsideClick: true,
    };

    constructor(props) {
        super(props);

        this.originalPointerEvents = null;
        this.originalOverflow = null;
        this.originalBodyPosition = null;
        this.originalBodyWidth = null;
    }

    componentDidMount() {
        document.addEventListener('keyup', this._onKeyUp);
        this._setVerticalOffset();
        this._preventPointerEventsAndScroll();
        this._iOS11InputInFixedContainerFix();
    }

    componentWillUnmount() {
        document.removeEventListener('keyup', this._onKeyUp);
        this._restoreiOS11InputInFixedContainerFix();
        this._restorePointerEventsAndScroll();
        this._restoreVerticalOffset();
    }

    _preventPointerEventsAndScroll() {
        this.originalBodyPointerEvents = document.body.style.pointerEvents;
        this.originalBodyOverflow = document.body.style.overflow;

        document.body.style.pointerEvents = 'none';
        document.body.style.overflow = 'hidden';
    }

    _restorePointerEventsAndScroll() {
        document.body.style.pointerEvents = this.originalBodyPointerEvents;
        document.body.style.overflow = this.originalBodyOverflow;
    }

    // See https://bugs.webkit.org/show_bug.cgi?id=176896
    _iOS11InputInFixedContainerFix() {
        this.originalBodyPosition = document.body.style.position;
        this.originalBodyWidth = document.body.style.width;

        document.body.style.position = 'fixed';
        document.body.style.width = '100%';
    }

    _restoreiOS11InputInFixedContainerFix() {
        document.body.style.position = this.originalBodyPosition;
        document.body.style.width = this.originalBodyWidth;
    }

    _setVerticalOffset() {
        this.originalTop = document.body.style.top;
        this.originalScrollTop = window.pageYOffset;

        document.body.style.top = `-${this.originalScrollTop}px`;
    }

    _restoreVerticalOffset() {
        document.body.style.top = this.originalTop;
        window.scrollTo(0, this.originalScrollTop);
    }

    _onClick = (e) => {
        // don't let events escape the lightbox and induce unwanted behavior in parents
        e.stopPropagation();
    };

    _onHide = (e) => {
        e.stopPropagation();
        e.preventDefault();
        this.props.onHide(e);
    };

    _onKeyUp = (e) => {
        const { onHide } = this.props;
        if (e.key !== 'Escape') {
            return;
        }

        onHide(e);
    };

    _onOutsideClick = (e) => {
        const {
            closeModalOnOutsideClick,
            onHide,
        } = this.props;

        if (closeModalOnOutsideClick) {
            onHide(e);
        }
    };

    render() {
        const {
            id,
            className,
            innerClassName,
            children,
            showCloseButton,
            title,
            newTitleStyle = false,
            scrollable = false,
        } = this.props;

        return (
            <div
                className={classNames(className, styles.lightboxBackground)}
                id={id}
                onClick={this._onClick}
            >
                <OutsideClick
                    className={classNames(innerClassName, styles.lightboxInner, {
                        [styles.scrollable]: scrollable,
                    })}
                    onOutsideClick={this._onOutsideClick}
                >
                    {!!title && (
                        <div className={classNames({
                            [styles.newTitleContainer]: newTitleStyle,
                            [styles.titleContainer]: !newTitleStyle,
                        })}>
                            {title}
                        </div>
                    )}

                    {scrollable
                        ? (
                            <div className={styles.scrollContainer}>{children}</div>
                        )
                        : children}

                    {showCloseButton && (
                        <button
                            className={classNames(styles.closeButton, {
                                [styles.newTitleStyle]: newTitleStyle,
                            })}
                            onClick={this._onHide}
                            role="button"
                            title="Close"
                        >
                            <CloseX />
                        </button>
                    )}
                </OutsideClick>
            </div>
        );
    }
}

export default Lightbox;
